// extracted by mini-css-extract-plugin
module.exports = {"container":"BotOverviewContent_container__2Tip3"};